/** @param {string} SET_USERNAME_DATA 传入会员资料 */
export const SET_USERNAME_DATA = 'SET_USERNAME_DATA'

/** @param {string} SETTING_USER_PERMISSION 設定操作員組權限 */
export const SETTING_USER_PERMISSION = 'SETTING_USER_PERMISSION'

/** @param {number} SET_GAMEID 传入使用者游戏类别id */
export const SET_GAMEID = 'SET_GAMEID'

export const ACOUNTS = 'ACOUNTS'
export const CHANGE_CHODD = 'CHANGE_CHODD' 
export const OPTINONS = 'OPTINONS' 
export const CHGBACO = 'CHGBACO' 
export const CHGRSLOT = 'CHGRSLOT' 
export const INSTANBET = 'INSTANBET'
export const OPERATOR = 'OPERATOR'
export const OPERATOR_GROUP = 'OPERATOR_GROUP'
